<ion-header><app-navheader></app-navheader></ion-header>
<ion-content class="ion-no-padding">
  <ion-item class="header" lines="none">
    <ion-label class="ion-no-padding">
      <h1>{{'ACCOUNT.FORGOT_PASSWORD.HEADER' | translate}}!</h1>
    </ion-label>
  </ion-item>
  <div class="wrapper">
    <div class="text-wrapper">{{ 'ACCOUNT.FORGOT_PASSWORD.TEXT_1' | translate }} {{ 'ACCOUNT.FORGOT_PASSWORD.TEXT_2' | translate }}</div>
    <div class="text-wrapper">{{ 'ACCOUNT.FORGOT_PASSWORD.TEXT_3' | translate }}</div>
    <form #loginForm ="ngForm">
        <ion-item class="firstinput ion-no-padding" lines="none">
          <ion-label position="stacked">{{ 'ACCOUNT.LOGIN.EMAIL_LABEL' | translate }}</ion-label>
          <ion-input (ionBlur)="checkOnBlur()"  [ngClass]="{'emailvalidation': !validation && userstatus}" type="text" name="username" id="username" [(ngModel)]="model.username" #username="ngModel"></ion-input>
        </ion-item>
        <div class="errortext" [ngClass]="{'visible': !validation && userstatus}">{{'ERROR.EMAIL.INVALID' | translate }}</div>
      <ion-button class="createuser" (click)="sendEmail()">{{ 'ACCOUNT.FORGOT_PASSWORD.BUTTON' | translate }}</ion-button>
    </form>
  </div>
  <app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer>
  <app-bottom-menu></app-bottom-menu>
</ion-footer>
